<template>
  <div
    id="chatinput"
    style="bottom: 0; right: 0; left: 0"
    :style="{ position: isMobile ? 'fixed' : 'absolute' }"
  >
    <slot name="header"></slot>
    <div style="background: white; border-top: 1px solid #eee; position: relative">
      <div class="pl-2 pt-3">
        <v-radio-group v-model="replytype" row class="ma-0">
          <v-radio label="Reply to comment" value="replytocomment" color="primary"></v-radio>
          <v-radio
            label="Reply to inbox"
            value="replytoinbox"
            color="primary"
            :disabled="!user.profile_pic"
          ></v-radio>
          <span v-if="!user.profile_pic" class="gray--text pt-1" style="font-size: 12px">
            <v-tooltip top>
              <template v-slot:activator="{ on }">
                <em class="fas fa-question-circle" dark v-on="on" style="font-size: 16px" />
              </template>
              <span>(ลูกค้าต้องมีการเชื่อมต่อกับ inbox ของเพจแล้วเท่านั้น)</span>
            </v-tooltip>
          </span>
        </v-radio-group>
      </div>
      <form v-on:submit.prevent="noop">
        <v-layout>
          <v-avatar size="30" class="ma-1">
            <img
              @error="onError"
              :src="
                'https://graph.facebook.com/' +
                selectedBot.pageid +
                '/picture?width=100&height=100&SameSite=None'
              "
              style="border: 1px solid #eee"
            />
          </v-avatar>
          <v-flex class="pa-1">
            <autoresize-textarea
              v-model="text"
              rows="1"
              placeholder="Type message"
              :class="{
                black_input_font: [
                  '102052945584054',
                  '106855151601601',
                  '111901618984646'
                ].includes(livechat.pageid)
              }"
              style="
                resize: none;
                border: 1px solid #eee;
                padding: 5px;
                border-radius: 5px;
                outline: 0px;
                background: none;
                display: inline-block;
              "
              @pressEnter="$refs.sendBtn.click()"
              @onPaste="onPaste"
            ></autoresize-textarea>
          </v-flex>

          <v-flex shrink class="text-xs-right" style="white-space: nowrap">
            <!-- Send image -->
            <span>
              <v-dialog v-model="showUploadImg" max-width="700">
                <template v-slot:activator="{ on }">
                  <span>
                    <v-btn icon style="margin: 0" v-tooltip.top="'Send Image'" v-on="on">
                      <v-icon class="outlined">photo_size_select_actual</v-icon>
                    </v-btn>
                  </span>
                </template>
                <v-card>
                  <div class="text-xs-right">
                    <v-btn @click="showUploadImg = false" fab flat color="primary" small>
                      <v-icon>close</v-icon>
                    </v-btn>
                  </div>
                  <v-card-text v-if="showUploadImg">
                    <div>
                      <uploadfile
                        ref="answer"
                        v-model="image_url"
                        @onUploaded="onUploaded"
                        v-validate
                        :multiple="true"
                      ></uploadfile>
                    </div>
                  </v-card-text>
                </v-card>
              </v-dialog>
            </span>
            <template>
              <span>
                <v-dialog v-model="showIntent" max-width="700">
                  <template v-slot:activator="{ on }">
                    <span>
                      <v-btn icon style="margin: 0" v-tooltip.top="'Quick Message'" v-on="on">
                        <v-icon class="outlined">forum</v-icon>
                      </v-btn>
                    </span>
                  </template>
                  <v-card>
                    <v-card-text v-if="showIntent">
                      <div class="text-xs-right">
                        <v-btn @click="showIntent = false" fab depressed color="primary" small>
                          <v-icon>close</v-icon>
                        </v-btn>
                      </div>
                      <intent
                        :livechat="true"
                        :key="selectedBot.pageid"
                        :pageid="selectedBot.pageid"
                        :showDefault="false"
                        @sendToLivechat="sendMessage"
                      ></intent>
                    </v-card-text>
                  </v-card>
                </v-dialog>
              </span>
              <span>
                <v-btn
                  ref="sendBtn"
                  depressed
                  fab
                  color="primary"
                  small
                  :disabled="!enableSend"
                  :loading="IsSending"
                  @click="clickSendBtn"
                  v-tooltip.top="'Send'"
                >
                  <em class="fa fa-send" />
                </v-btn>
              </span>
            </template>
          </v-flex>
        </v-layout>
      </form>
    </div>
  </div>
</template>

<script>
import AutoresizeTextarea from '@/components/view/livechat/AutoresizeTextarea'
import { mapGetters } from 'vuex'
import Intent from '@/components/view/intent/Intent'
import uploadfile from '@/components/elements/uploadfile'
import uploadalltype from '@/components/elements/uploadalltype'
import moment from 'moment'
import UploadSingleFile from '@/components/elements/UploadSingleFile.js'
import api from '@/api'

export default {
  props: ['value', 'app', 'hasNewMessage', 'refreshChatInput'],
  mixins: [UploadSingleFile],
  data: function () {
    return {
      type: 'text',
      text: '',
      enableSend: false,
      user: this.value,
      isMobile: false,
      showIntent: false,
      showUploadImg: false,
      showToaProduct: false,
      image_url: null,
      showUploadFile: false,
      file_url: null,
      showSticker: false,
      showEmoji: false,
      isreply: false,
      holdstatus: false,
      holdadminId: null,
      confirmSend: [],
      showHoldDialog: false,
      holdaction: null,
      holdmsg: '',
      IsSending: false,
      replytype: 'replytocomment'
    }
  },
  computed: {
    ...mapGetters({
      selectedBot: 'selectedBot',
      linePushMessageCount: 'getLoadingLinePushMessageCount',
      loadingLinePushMessageCount: 'getLinePushMessageCount',
      botlist: 'botlist',
      livechat: 'livechat',
      currentUserTicket: 'currentUserTicket'
    }),
    currentTheme() {
      return this.$store.state.livechat.theme
        ? this.$store.state.livechat.theme
        : this.selectedBot.theme
    }
  },
  components: {
    AutoresizeTextarea,
    Intent,
    uploadfile,
    uploadalltype
  },
  beforeDestroy() {
    if (typeof window !== 'undefined') {
      window.removeEventListener('resize', this.onResize, { passive: true })
    }
  },
  async mounted() {
    this.onResize()
    window.addEventListener('resize', this.onResize, { passive: true })
  },
  methods: {
    async onPaste(evt) {
      var items = (evt.clipboardData || evt.originalEvent.clipboardData).items
      for (var index in items) {
        var item = items[index]
        if (item.kind === 'file') {
          var blob = item.getAsFile()
          let base64 = await this.renderImage(blob)
          let result = await this.$swal.fire({
            title: 'Do you want to send this image?',
            html: `<img src="${base64}" style="max-height: 250px; max-width: 400px;">`,
            // imageUrl: base64,
            // imageWidth: 400,
            // imageHeight: 250,
            showCancelButton: true,
            confirmButtonText: this.$t('Confirm'),
            cancelButtonText: this.$t('cancel'),
            reverseButtons: true
          })

          if (result.value) {
            this.$store.dispatch('loading')
            try {
              let url = await this.validateFile([blob])
              if (url) {
                this.onUploaded([url])
              }
            } catch (error) {
              console.error(error)
            }
            this.$store.dispatch('loading')
          }
        }
      }
      if (evt.clipboardData.getData('text') && evt.clipboardData.getData('text').trim() != '') {
        this.enableSend = true
      } else {
        this.enableSend = false
      }
    },
    renderImage(blob) {
      return new Promise((resolve, reject) => {
        try {
          var reader = new FileReader()
          reader.onload = function (event) {
            resolve(event.target.result)
          }
          reader.readAsDataURL(blob)
        } catch (error) {
          reject(error)
        }
      })
    },
    clickSendBtn() {
      if (!this.text || this.text.trim() == '') return false
      let data = {
        a_val: JSON.stringify([[{ text: this.text, type: 'text' }]]),
        type: 'json'
      }
      this.sendMessage(data)
    },
    chatboxEnter(event) {},
    onUploadedFile(url) {
      this.enableSend = true
      var files = [[]]

      if (typeof url == 'string') {
        if (url.indexOf('.mp4') != -1) {
          files[0].push({ source: url, type: 'video' })
        } else {
          files[0].push({ text: url, type: 'text' })
        }
      } else {
        url.forEach((el) => {
          if (el.indexOf('.mp4') != -1) {
            files[0].push({ source: el, type: 'video' })
          } else {
            files[0].push({ text: el, type: 'text' })
          }
        })
      }
      let data = {
        a_val: JSON.stringify(files),
        type: 'json'
      }

      this.sendMessage(data)
      this.file_url = null
      this.showUploadFile = false
    },
    onUploaded(url) {
      this.enableSend = true
      var images = [[]]
      if (typeof url == String) {
        images[0].push({ image_url: url, type: 'image' })
      } else {
        url.forEach((el) => {
          images[0].push({ image_url: el, type: 'image' })
        })
      }
      let data = {
        a_val: JSON.stringify(images),
        type: 'json'
      }

      this.sendMessage(data)
      this.showUploadImg = false
      this.image_url = null
    },
    newline() {
      this.text = '${this.text}\n'
    },
    onError: function (event) {
      $(event.target).attr('src', '/static/img/assets/livechat/profile.png')
    },

    async sendMessage(event) {
      var vm = this
      const pageid = vm.selectedBot.pageid
      const userid = vm.user.userid

      this.IsSending = true
      this.showIntent = false
      // let isIntent = event && event.type == 'intent'
      if (vm.selectedBot.pageid == null && vm.user.userid == null) {
        return false
      }
      var bot = this.botlist.find((el) => {
        return el.pageid == this.selectedBot.pageid
      })
      if (!bot) return false
      var type = event.a_type ? event.a_type /* from quickmessage */ : event.type

      let dataChatlog = {
        pageid: vm.selectedBot.pageid,
        limit: vm.limit,
        offset: vm.offset,
        postid: vm.$store.state.rabbitSelectedPostId,
        userid: userid
      }

      api.getRabbitChatlogWithPost(dataChatlog, async (error, response) => {
        var res = response
        let replytype = this.replytype
        let data

        if (res.data) {
          if (replytype == 'replytocomment') {
            data = {
              pageid: vm.selectedBot.pageid,
              userid: vm.user.userid,
              app: 'facebook',
              adminid: vm.$store.state.userid,
              messagetype: type,
              status: null,
              messagevalue: type == 'json' ? event.a_val : vm.text,
              post_id: res.data[0].postid,
              comment_id: vm.user.commentid
            }
          } else {
            // reply to inbox
            data = {
              pageid: vm.selectedBot.pageid,
              userid: vm.user.userid,
              app: 'facebook',
              adminid: vm.$store.state.userid,
              messagetype: type,
              status: null,
              messagevalue: type == 'json' ? event.a_val : vm.text
            }
          }
        }

        if (event.a_type) {
          Object.assign(data, {
            context_in: event.context_in,
            context_out: event.context_out,
            userstatus: event.userstatus,
            usertags: event.usertags
          })
        }

        if (event.quick_reply) {
          Object.assign(data, { quick_reply: event.quick_reply })
        }

        let message = {
          answerby: 'admin',
          id: new Date().getTime(),
          messagedata:
            type == 'json'
              ? JSON.parse(event.a_val).length > 0
                ? JSON.stringify(JSON.parse(event.a_val)[0])
                : event.a_val
              : vm.text,
          messagetype: type,
          pageid: vm.selectedBot.pageid,
          timestamp: new Date(),
          userid: vm.user.userid,
          adminid: vm.$store.state.userid,
          replytype: replytype
        }

        api.postRabbitSendMessage(data, async (error, response) => {
          vm.IsSending = false
          vm.text = ''
          if (error) {
            console.log(error)
            vm.$swal.fire({
              type: 'error',
              text: 'ไม่สามารถส่งข้อความได้'
            })
            return
          }
          vm.$emit('onSendMessage', message)
        })
      })
    },
    onConfirmSendMessage(action) {
      this.confirmSend.push({
        pageId: this.livechat.pageid,
        userId: this.livechat.currentUser.userid
      })
      if (action == 'send') {
        this.clickSendBtn()
        this.showHoldDialog = false
        this.holdaction = ''
      }
    },
    onResize() {
      this.isMobile = window.innerWidth < 960
    }
  },
  watch: {
    text: function (newVal, oldVal) {
      if (newVal && newVal.trim() != '') {
        this.enableSend = true
      } else {
        this.enableSend = false
      }
    },
    value: function (newVal, oldVal) {
      this.user = this.value
      this.replytype = 'replytocomment'
    },
    hasNewMessage(newVal, oldVal) {
      if (newVal != oldVal) {
        if (this.hasNewMessage) {
          this.holdstatus = false
          this.holdadminId = ''
        }
      }
    },
    refreshChatInput(newVal, oldVal) {
      if (newVal != oldVal) {
        this.holdstatus = this.refreshChatInput.holdstatus
        this.adminhold = this.refreshChatInput.adminhold
      }
    }
  }
}
</script>

<style scoped>
.black_input_font {
  color: black;
}
</style>



// WEBPACK FOOTER //
// src/components/view/template/ticket/RabbitReplyFBPost/ChatInput.vue